const ALPHA_NUMERIC_REGEX = /^[A-Za-z0-9]+$/; // Example - "JohnDoe123"
const ALPHA_NUMERIC_WHITESPACE_REGEX = /^[0-9A-Za-z -]+$/; // Example - "John Doe 123"
// Requires ≥1 letter or digit; other chars may be any non-whitespace (e.g. hyphens in "REF-FROM-API")
// Rejects pure punctuation/symbol strings (e.g. "@@@@", "____")
const ALPHA_NUMERIC_SPECIAL_CHARS_REGEX = /^(?=.*[A-Za-z0-9])[^\s]+$/;
const ALPHABETIC_REGEX = /^[A-Za-z\s]+$/;
const CITY_REGEX = /^[A-Za-z\s'\.\-]+$/; // Example: "New York" (Match), "Los Angeles" (Match), "San Francisco"
const COMPLETE_INPUT = /_/; // check if string has underscore -- complete if input is completely filled is masked ex - 21/__/____ 
const COUNT_REGEX = /^[0-9]+$/; // Examples: "123" (Match), "0" (Match), "456789" (Match), "123abc" (No match), "abc123" (No match)
const COUNTY_REGEX = /^[a-zA-Z .]+$/; // Examples: "Los Angeles" (Match), "San Francisco" (Match), "New York" (Match), "123 County" (No match), "County@Name" (No match)
const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // MM/DD/YYYY
const DATE_OF_BIRTH = /^\d{2}\/\d{2}\/\d{4}$/; // Examples: "12/31/1999" (Match), "01/01/2023" (Match), "31/12/1999" (No match)
const DATE_REGEX = /^\d{2}-\d{2}-\d{4}$/;
const DIGIT_ONLY_REGEX = /\D/g;
const EMAIL_REGEX = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
const FIRST_NAME_REGEX = /^(?=.{1,50}$)[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/;
const HASHTAG_REGEX = /#([^#\n]*)$/;
const HOUSEHOLD_REGEX = /^[0-9]$/; // Examples: "0" (Match), "5" (Match), "9" (Match), "10" (No match), "a" (No match)
const INPUT_SSN_REGEX = /-/g;
const INTEGER_REGEX = /^-?\d+$/; // Match -> -123, 0, 123, 1234567890, No match -> 123.45, 123abc, abc123, 123abc456
const LAST_NAME_REGEX = /^(?=.{1,50}$)[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/;
const MASK_EMAIL = /^(.)(.*)(@.*)$/; // Example - jdoe@example.com → j******@example.com
const MASK_SMS = /(\d{3})(\d{3})(\d{4})/; // Example - 123-456-7890 → xxx-xxx-7890
const MEDICAID_ID_REGEX = /^[0-9a-zA-Z-]{1,30}$/; // Examples: "12345" (Match), "ABC-12345" (Match), "123-ABC-6789" (Match), "123456789012345678901234567890" (Match), "1234567890123456789012345678901" (No match), "123@ABC" (No match)
const NUMERIC_INPUT_REGEX = /^-?\d*$/;
const PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/; // Examples: "(123) 456-7890" (Match), "(987) 654-3210" (Match), "123-456-7890" (No match), "(123)456-7890" (No match)
// PII detection patterns for log sanitization
// These patterns are designed to match PII in various formats within log messages
const PII_EMAIL_REGEX = /[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}/;
const PII_SSN_REGEX = /\b\d{3}-?\d{2}-?\d{4}\b/;
const PII_PHONE_REGEX = /\b(?:\+?1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}\b/;
const PII_ZIP_CODE_REGEX = /\b\d{5}(?:-\d{4})?\b/;
const REGEX_WITH_ACCENTEDCHARS = /^(?:[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ' .-]*|)$/;
const SSN_REGEX = /^[0-9]{4}$/; // Examples: "1234" (Match), "5678" (Match), "12345" (No match), "abcd" (No match)
const ZIP_CODE_REGEX = /^[0-9]{5}$/; // Examples: "12345" (Match), "67890" (Match), "1234" (No match), "123456" (No match)

export {
    ALPHA_NUMERIC_REGEX,
    ALPHA_NUMERIC_WHITESPACE_REGEX,
    ALPHA_NUMERIC_SPECIAL_CHARS_REGEX,
    ALPHABETIC_REGEX,
    CITY_REGEX,
    COMPLETE_INPUT,
    COUNT_REGEX,
    COUNTY_REGEX,
    DATE_MASK,
    DATE_OF_BIRTH,
    DATE_REGEX,
    DIGIT_ONLY_REGEX,
    EMAIL_REGEX,
    FIRST_NAME_REGEX,
    HASHTAG_REGEX,
    HOUSEHOLD_REGEX,
    INPUT_SSN_REGEX,
    INTEGER_REGEX,
    LAST_NAME_REGEX,
    MASK_EMAIL,
    MASK_SMS,
    MEDICAID_ID_REGEX,
    NUMERIC_INPUT_REGEX,
    PHONE_REGEX,
    PII_EMAIL_REGEX,
    PII_PHONE_REGEX,
    PII_SSN_REGEX,
    PII_ZIP_CODE_REGEX,
    REGEX_WITH_ACCENTEDCHARS,
    SSN_REGEX,
    ZIP_CODE_REGEX,
};
